import React from "react";
import AppRoutes from "./routers/route";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider, useTheme } from "./context/ThemeContext";
import { WhatsAppAccountProvider } from "./context/WhatsAppAccountContext";
import ErrorBoundary from "./components/ErrorBoundary";

const ThemedToastContainer = () => {
  const { isDark } = useTheme();
  return (
    <ToastContainer
      theme={isDark ? "dark" : "light"}
      closeOnClick
      autoClose={2000}
      position="top-right"
      transition={Zoom}
    />
  );
};

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ThemeProvider>
          <WhatsAppAccountProvider>
            <ThemedToastContainer />
            <AppRoutes />
          </WhatsAppAccountProvider>
        </ThemeProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;

